import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Invoice\SearchInvoiceableController::__invoke
* @see app/Http/Controllers/Invoice/SearchInvoiceableController.php
* @route '/api/invoicing/search-invoiceable'
*/
const SearchInvoiceableController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: SearchInvoiceableController.url(options),
    method: 'get',
})

SearchInvoiceableController.definition = {
    methods: ["get","head"],
    url: '/api/invoicing/search-invoiceable',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Invoice\SearchInvoiceableController::__invoke
* @see app/Http/Controllers/Invoice/SearchInvoiceableController.php
* @route '/api/invoicing/search-invoiceable'
*/
SearchInvoiceableController.url = (options?: RouteQueryOptions) => {
    return SearchInvoiceableController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\SearchInvoiceableController::__invoke
* @see app/Http/Controllers/Invoice/SearchInvoiceableController.php
* @route '/api/invoicing/search-invoiceable'
*/
SearchInvoiceableController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: SearchInvoiceableController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Invoice\SearchInvoiceableController::__invoke
* @see app/Http/Controllers/Invoice/SearchInvoiceableController.php
* @route '/api/invoicing/search-invoiceable'
*/
SearchInvoiceableController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: SearchInvoiceableController.url(options),
    method: 'head',
})

export default SearchInvoiceableController